import { IconButton } from '@mui/material';
import { Star } from '@mui/icons-material';
import { OneMedia } from '@prismamedia/one-components';
import { EditorState } from 'draft-js';
import { BlockItemDesktop } from 'pages/CampaignPage/CampaignEditPage/ContentPage/Items/desktop/BlockItem';
import { BlockItemMobile } from 'pages/CampaignPage/CampaignEditPage/ContentPage/Items/mobile/BlockItem';
import { BlockItemType } from 'pages/CampaignPage/CampaignEditPage/ContentPage/Items/utils';
import {
  actions,
  CampaignSectionAction,
} from 'pages/CampaignPage/CampaignEditPage/ContentPage/reducer';
import { useDisplayArticles } from 'pages/CampaignPage/CampaignEditPage/ContentPage/utils/useDisplayArticles';
import { Dispatch, FC, memo } from 'react';
import { BlockItemFormat } from '../../Items/desktop/BlockItem';
import { useStyles } from './styles';

interface BlockProps {
  blockItem: BlockItemType;
  compactView: boolean;
  dispatch: Dispatch<CampaignSectionAction>;
  sectionId: string;
}

export const Block: FC<BlockProps> = memo(
  ({ blockItem, dispatch, sectionId, compactView }) => {
    const classes = useStyles();
    const handleEditField = (
      field: string,
      value: string | OneMedia | EditorState,
    ) => {
      dispatch(
        actions.updateField({
          sectionId,
          blockId: blockItem.id,
          field,
          value,
        }),
      );
    };

    const handleDeleteArticle = () => {
      dispatch(actions.deleteBlock({ sectionId, blockId: blockItem.id }));
    };

    const handleLeadInArticle = () => {
      dispatch(actions.setLeadIn({ sectionId, blockId: blockItem.id }));
    };

    const { isMobile } = useDisplayArticles();
    const isCompactView = isMobile || compactView;

    return (
      <div className={classes.root}>
        <IconButton
          size="small"
          className={classes.star}
          onClick={() =>
            dispatch(actions.setLeadIn({ sectionId, blockId: blockItem.id }))
          }
        >
          <Star color={blockItem.leadIn ? 'primary' : 'inherit'} />
        </IconButton>

        {!isCompactView && (
          <BlockItemDesktop
            format={
              blockItem.isAutoPromo
                ? BlockItemFormat.AUTO_PROMO
                : BlockItemFormat.EXPANDED
            }
            item={blockItem}
            onDeleteBlock={handleDeleteArticle}
            onSetLeadIn={handleLeadInArticle}
            onEditField={handleEditField}
          />
        )}

        {isCompactView && (
          <BlockItemMobile
            format={
              blockItem.isAutoPromo
                ? BlockItemFormat.AUTO_PROMO
                : BlockItemFormat.EXPANDED
            }
            item={blockItem}
            onDeleteBlock={handleDeleteArticle}
            onSetLeadIn={handleLeadInArticle}
            onEditField={handleEditField}
            isDesktop={compactView}
          />
        )}
      </div>
    );
  },
);
